module.exports = __webpack_public_path__ + "static/media/avatar.b7f30dec.jpg";